// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".summary-card-switch.has-tag .custom-switch{padding-right:5.5rem}.summary-card-switch .auto-tag{font-size:10.5px;letter-spacing:.03em;position:absolute;right:0;top:2px}.summary-card-switch .auto-tag.man{cursor:pointer;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
